import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"ภาษีเงินได้นิติบุคคล (CIT) — วางแผน ยื่น ภ.ง.ด.50/51","metaTitle":"ภาษีนิติบุคคล CIT ไทย — ยื่น ภ.ง.ด.50/51 SME BOI | NYC","metaDesc":"วางแผนและยื่นภาษีเงินได้นิติบุคคล ภ.ง.ด.50 (ปลายปี) ภ.ง.ด.51 (กลางปี) รวมสิทธิ SME 15%, BOI 0-8 ปี พร้อม Transfer — ทีมงานตอบไวทุกวัน ปรึกษาก่อนตัดสินใจได้ฟรี"},"en":{"h1":"Thailand Corporate Income Tax (CIT) — PND.50/51 Filing & Planning","metaTitle":"Thailand Corporate Income Tax — PND.50/51 SME BOI TP | NYC","metaDesc":"Corporate tax planning and filing — PND.50 (year-end) and PND.51 (mid-year), SME 15% band, BOI 0-8 year ho — Send your documents for a free eligibility check."}} as const;

export const Route = createFileRoute("/en/tax/corporate-cit")({
  head: () => {
    const url = `${SEO_SITE}/en/tax/corporate-cit`;
    const c = meta.en;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/en/tax/corporate-cit", "en")},
        { name: "description", content: ctaDesc(c.metaDesc, "/en/tax/corporate-cit", "en")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/en/tax/corporate-cit", "en")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/en/tax/corporate-cit", "en")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "en_US" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/tax/corporate-cit", "/en/tax/corporate-cit")],
    };
  },
  component: () => <SubServicePage slug="tax/corporate-cit" locale="en" />,
});
